module.exports = __webpack_public_path__ + "img/xiazai.b47bcee2.png";